// import Splide from '@splidejs/splide';
// import '@splidejs/splide/dist/css/splide.min.css';


import { Splide } from '../../index.js';


document.addEventListener('DOMContentLoaded', () => {
  const elem = document.querySelector('.slider-gallery-v1 .splide');
  if (!elem) return;

  const splide = new Splide(elem, {
    type      : 'loop',
    gap       : '1rem',
    arrows    : false,        // usiamo i bottoni esterni
    pagination: false,        // dots solo su mobile (breakpoints sotto)
    perPage   : 4,
    // lazyLoad  : 'nearby',

    breakpoints: {
      1024: { perPage: 2 },        // tablet
      768 : { perPage: 1, pagination: true }, // mobile
    },
  });

  // Prima montiamo Splide
  splide.mount();

  // Dopo il mount, configuriamo i pulsanti
  const slider = elem.closest('.slider-gallery');
  const prevButton = slider?.querySelector('.splide-button-prev');
  const nextButton = slider?.querySelector('.splide-button-next');

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => {
      console.log('Prev click');
      // Usiamo il Controller attraverso Components
      splide.Components.Controller.go('-1');
    });
    
    nextButton.addEventListener('click', () => {
      console.log('Next click');
      // Usiamo il Controller attraverso Components
      splide.Components.Controller.go('+1');
    });

    // Aggiungiamo anche gli event listener di Splide
    splide.on('arrows:mounted', function() {
      console.log('Arrows mounted');
    });

    // Debug
    console.log('Splide instance:', splide);
    console.log('Splide methods:', Object.keys(splide));
  }
});


